/*
 * Megamenu card photographs.
 *
 * The cards are lazy in the markup so that a phone, which never draws the megamenu, does
 * not download them. Left at that, a desktop visitor's first hover would open a menu with
 * its cards still loading. So where the megamenu exists (1400px and up) they are fetched
 * once the page itself has loaded and the browser is idle.
 */
(function () {
  'use strict';

  function fetchCards() {
    if (!window.matchMedia('(min-width: 1400px)').matches) return;

    document.querySelectorAll('.header__nav .header__card img[loading="lazy"]').forEach(function (image) {
      image.loading = 'eager';
    });
  }

  function whenIdle() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fetchCards, { timeout: 4000 });
    else window.setTimeout(fetchCards, 1500);
  }

  if (document.readyState === 'complete') whenIdle();
  else window.addEventListener('load', whenIdle);
})();
